import React from "react";
import SelectAutoCompleteMultiple from "components/SelectAutoCompleteMultipleG";
import DatePickerRangeG from "components/DatePickerRangeG";
import { useListarEmpreendimentosFunil } from "services/api/Funil_Propostas/listar-empreendimentos";
import * as S from "./styles";
import * as IconsSVG from "../../../../assets/iconsSVG";
import SelectComponent from "../../../../components/selectAutoCompleteG";

interface Option {
  value: string;
  label: string;
}
interface EtapasItem {
  codigo: string;
  nome: string;
}

interface Props {
  etapas: EtapasItem[];
  subEtapas: EtapasItem[];
}

interface Data {
  selectedEtapa: Option | null;
  handleEtapaChange: (newValue: Option | null) => void;
  selectedSubetapa: Option[];
  handleSubetapaChange: (
    event: React.SyntheticEvent<Element, Event>,
    newValues: Option[] | null
  ) => void;
  handleClearFilters: () => void;
  handleApplyFilters: () => void;
  dataEtapasFiltro: Props;
  dataSubEtapasFiltro: Props;
  isFetchingSubEtapasFiltro: boolean;
  selectedEmpreendimento: Option[];
  handleEmpreendimentoChange: (
    event: React.SyntheticEvent<Element, Event>,
    newValues: Option[] | null
  ) => void;
  selectedTipoFiltroData: Option | null;
  handleTipoFiltroDataChange: (newValue: Option | null) => void;
  tipoFiltroDataOptions: Option[];
  dataInicio: Date | null;
  dataFim: Date | null;
  handleDataInicioChange: (newDate: Date | null) => void;
  handleDataFimChange: (newDate: Date | null) => void;
}

const Filtro = (data: Data) => {
  const { data: dataEmpreendimentos } = useListarEmpreendimentosFunil();
  return (
    <S.Content>
      <S.Row style={{ justifyContent: "space-between" }}>
        <IconsSVG.FilterModalIcon />
        <S.TextFilter>Filtros</S.TextFilter>
        <S.ButtonClear onClick={data.handleClearFilters}>Limpar</S.ButtonClear>
      </S.Row>
      <S.SpaceY space={32} />
      <S.Row>
        <S.DateFilterContainer>
          <S.DateFilterTitle>Filtrar por</S.DateFilterTitle>
          <S.RadioGroup
            aria-labelledby="tipo-filtro-data-funil-comercial"
            value={data.selectedTipoFiltroData?.value || ""}
            name="tipoFiltroDataFunilComercial"
            onChange={(event) => {
              const option =
                data.tipoFiltroDataOptions.find(
                  (item) => item.value === event.target.value
                ) || null;
              data.handleTipoFiltroDataChange(option);
            }}
          >
            {data.tipoFiltroDataOptions.map((option) => (
              <S.FormControlLabel
                key={option.value}
                value={option.value}
                control={
                  <S.Radio
                    checked={
                      data.selectedTipoFiltroData?.value === option.value
                    }
                    onClick={() => {
                      if (data.selectedTipoFiltroData?.value === option.value) {
                        data.handleTipoFiltroDataChange(null);
                      }
                    }}
                  />
                }
                label={option.label}
              />
            ))}
          </S.RadioGroup>
        </S.DateFilterContainer>
      </S.Row>

      {data.selectedTipoFiltroData && (
        <>
          <S.SpaceY space={12} />
          <S.Row>
            <DatePickerRangeG
              startDate={data.dataInicio}
              endDate={data.dataFim}
              onStartDateChange={data.handleDataInicioChange}
              onEndDateChange={data.handleDataFimChange}
              width="100%"
              disabled={false}
            />
          </S.Row>
        </>
      )}
      <S.SpaceY space={32} />
      <S.Row>
        <SelectAutoCompleteMultiple
          borderRadius="8px"
          data={
            dataEmpreendimentos?.data?.map((empreendimento: any) => ({
              value: empreendimento.id,
              label: empreendimento.nome,
            })) || []
          }
          placeholder="Selecione"
          label="Empreendimento"
          value={data.selectedEmpreendimento || []}
          disabled={false}
          onChange={data.handleEmpreendimentoChange}
        />
      </S.Row>
      <S.SpaceY space={32} />
      <S.Row>
        <SelectComponent
          borderRadius="8px"
          data={
            data.dataEtapasFiltro?.etapas?.map((etapa: EtapasItem) => ({
              value: etapa.codigo,
              label: etapa.nome,
            })) || []
          }
          placeholder="Selecione"
          label="Etapa"
          value={data.selectedEtapa}
          disabled={!data.dataEtapasFiltro}
          onChange={data.handleEtapaChange}
        />
      </S.Row>
      <S.SpaceY space={32} />
      <S.Row>
        <SelectAutoCompleteMultiple
          borderRadius="8px"
          data={
            data.dataSubEtapasFiltro?.subEtapas?.map((etapa: EtapasItem) => ({
              value: etapa.codigo,
              label: etapa.nome,
            })) || []
          }
          placeholder="Selecione"
          label="Subetapas"
          value={data.selectedSubetapa}
          onChange={data.handleSubetapaChange}
          isError={false}
          helperText="Você pode selecionar múltiplas subetapas"
          disabled={!data.selectedEtapa || data.isFetchingSubEtapasFiltro}
        />
      </S.Row>
      <S.SpaceY space={32} />
      <S.Row>
        <S.ButtonFilter
          disabled={
            (!data.selectedSubetapa[0] && data.selectedEtapa) ||
            (!!data.selectedTipoFiltroData &&
              (!data.dataInicio || !data.dataFim))
          }
          onClick={() => {
            data.handleApplyFilters();
          }}
        >
          Aplicar Filtro
        </S.ButtonFilter>
      </S.Row>
    </S.Content>
  );
};

export default Filtro;
